import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { images } from "../../Images/Svg";
import style from "./Assignblock.module.css";
import Blocks from "./Blocks";
import {
  getBlocksAsPerLobName,
  getVendorBlock,
  putReassignVendor,
} from "../../Services/approval.service";
import useToaster from "../../customHook/useToaster";
import { vendorCountNumber } from "../../Utils/helper";
import VendorCount from "./VendorCount";
import VendorCountCard from "./VendorCountCard";
import {
  assignedBlocks,
  reassignVendorAuto,
} from "../../Services/caseManagement.service";
import { useDispatch, useSelector } from "react-redux";
import { isLoadingStateReducer } from "../../Redux/Slice/loginSlice";
import CommonModal from "../Modal/CommonModal";
import { getLocationList } from "../../Services/caseManagement.service";
import ManuallyAssignCase from "../../Pages/Approval/ManuallyAssignCase";
const { backArrowBold } = images;

const Assignblock = ({ isReassign = false }) => {
  const [investigatorDetails, setInvestigatorDetails] = useState([]);
  const [blockDetails, setBlockDetails] = useState([]);
  const [modifiedBlockData, setModifiedBlockData] = useState([]);
  const [assignDataList, setAssignDataList] = useState([]);
  const [selectValue, setSelectValue] = useState("");
  const [dataToSend, setDataToSend] = useState([]);
  const [dropdownData, setDropdownData] = useState([]);
  const [isManualAssignModelOpen, setIsManualAssignModelOpen] = useState(false);
  const [manualPopupData, setManualPopupData] = useState(null);
  const { showToast } = useToaster();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { vendorId, reassignType } = useParams();
  const caseId = useSelector((state) => state?.CaseDescriptionSlice?.caseId);
  const [isFilterPopOverActive, setIsFilterPopOverActive] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const lobName = useSelector((state) => state?.CaseDescriptionSlice?.lobName);
  const canBeOpen = isFilterPopOverActive && Boolean(anchorEl);
  const id = canBeOpen ? "spring-popper" : undefined;
  const isAllocatedCase = useSelector(
    (state) => state?.CaseDescriptionSlice?.isAllocatedCase
  );

  const onAssignBlockHandler = useCallback(
    (data, remarks) => {
      let isNoBlocksAssigned = data?.find(
        (obj) => !obj?.blocksAssigned?.length
      );
      if (isNoBlocksAssigned)
        return showToast(
          "Please assign blocks to all vendors",
          "warning",
          true
        );
      if (isReassign) {
        let investigations = [];
        data?.forEach((obj, index) => {
          let new_blocks, assigned_blocks;
          if (index === 0) {
            new_blocks =
              obj?.blocksAssigned?.filter(
                (blockId) =>
                  !investigatorDetails?.blocksAssigned?.includes(blockId)
              ) || [];
            assigned_blocks =
              obj?.blocksAssigned?.filter((blockId) =>
                investigatorDetails?.blocksAssigned?.includes(blockId)
              ) || [];
          } else {
            new_blocks = obj?.blocksAssigned || [];
            assigned_blocks =
              reassignType === "manual" ? obj?.blocksAssigned : [];
          }
          let newObj = {
            ...obj,
            case_allocation_id:
              index === 0 ? investigatorDetails?.case_allocation_id : null,
            new_blocks,
            assigned_blocks,
          };
          delete newObj.blocksAssigned;
          investigations?.push(newObj);
        });

        let payload = {
          case_id: caseId,
          last_rejection_reason: remarks,
          investigations,
        };

        if (reassignType === "manual") {
          setIsManualAssignModelOpen(true);
          setManualPopupData(payload);
          return;
        }
        if (isAllocatedCase) {
          reassignVendorAuto(reassignType === "same" ? "same" : "diff", payload)
            .then((res) => {
              if (res?.success) {
                navigate("/caseManagement");
                showToast(res?.message, "success", true);
              }
            })
            .catch((err) => {
              showToast(err?.response?.data?.message, "error", true);
            });
        } else {
          putReassignVendor(reassignType === "same" ? "same" : "diff", payload)
            .then((data) => {
              if (data?.success) {
                navigate("/approval");
                showToast(data?.message, "success", true);
              }
            })
            .catch((err) => {
              showToast(err?.response?.data?.message, "error", true);
            });
        }
        return;
      }

      assignedBlocks({ caseId, investigations: data })
        .then((data) => {
          if (data?.success) {
            navigate("/caseManagement");
            showToast("Case Allocated Successfully", "success", true);
          }
        })
        .catch((err) => {
          showToast(err?.response?.data?.message, "error", true);
        });
    },
    [caseId, investigatorDetails, isAllocatedCase]
  );

  const manualAssignHandler = (type) => {
    setManualPopupData(null);
    setIsManualAssignModelOpen(false);
    type === "Allocated" ? navigate("/caseManagement") : navigate("/approval");
  };

  const mapAssignedData = useCallback(
    (selectedVendors) => {
      let activeBlocks = modifiedBlockData
        ?.filter((obj) => obj?.isActive)
        ?.map((block) => block?.block_master_id);

      let previousSelectedBlocks = assignDataList
        ?.filter((data) => data?.isPrevSelected)
        ?.map((block) => block?.block_master_id);

      let selectedBlocks = [
        ...new Set([...activeBlocks, ...previousSelectedBlocks]),
      ];

      let dataForApi = dataToSend;
      let updateDataForApi = (vendorId) => {
        let assignedBlocks = dataForApi?.[vendorId - 1]?.blocksAssigned;
        if (selectedVendors?.includes(vendorId))
          assignedBlocks = vendorId === 1 ? selectedBlocks : activeBlocks;
        dataForApi[vendorId - 1].blocksAssigned = assignedBlocks;
      };
      const data = assignDataList?.map((item) => {
        let dataArr = {};
        let updateDataArr = (arr, isAssigned) => {
          dataArr = {
            ...item,
            investigator: arr,
            isAssigned,
          };
        };

        let setdataArrIfBlockSelected = () => {
          let arr = [...new Set([...selectedVendors, ...item?.investigator])];
          arr.sort((a, b) => a - b);
          updateDataArr(arr, true);

          //To update vendor blocks on dataToSend
          arr?.forEach(updateDataForApi);
        };
        let setdataArrIfBlockNotSelected = () => {
          let arr = [...item?.investigator];
          let isAssigned = false;
          if (arr?.some((item) => selectedVendors?.includes(item))) {
            arr = arr?.filter((item) => !selectedVendors?.includes(item));
          }
          //To set prev selected block on 1st vendor block
          if (item?.isPrevSelected && !arr?.includes(1)) arr?.push(1);
          if (arr?.length) isAssigned = true;
          updateDataArr(arr, isAssigned);
        };

        if (activeBlocks?.includes(item?.block_master_id)) {
          setdataArrIfBlockSelected();
        } else {
          setdataArrIfBlockNotSelected();
        }
        return dataArr;
      });

      setDataToSend(dataForApi);
      setAssignDataList(data);
      // setModifiedBlockData((prevData) => {
      //   return prevData.map((item) => ({
      //     ...item,
      //     isActive: false,
      //   }));
      // });
    },
    [
      dataToSend,
      assignDataList,
      modifiedBlockData,
      isReassign,
      investigatorDetails,
    ]
  );

  const onRemoveItem = (blockId, vendorId) => {
    setAssignDataList((prev) => {
      for (let i = 0; i < prev?.length; i++) {
        if (prev[i]?.block_master_id == blockId) {
          prev[i].investigator =
            prev[i]?.investigator?.filter((id) => id !== vendorId) || [];
          prev[i].isPrevSelected = false;
          if (!prev[i].investigator?.length) prev[i].isAssigned = false;
        }
      }
      return [...prev];
    });
    setDataToSend((prev) => {
      for (let i = 0; i < prev?.length; i++) {
        if (i + 1 === vendorId) {
          prev[i].blocksAssigned =
            prev[i]?.blocksAssigned?.filter((id) => id !== blockId) || [];
        }
      }
      return [...prev];
    });
  };

  const onApply = (selectedVendors) => {
    mapAssignedData(selectedVendors);
  };

  const handleChange = (e) => {
    setSelectValue(e?.target?.value);
  };

  const onBackClick = (e) => {
    navigate(-1);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setIsFilterPopOverActive((prev) => !prev);
  };

  useEffect(() => {
    dispatch(isLoadingStateReducer(true));
    getBlocksAsPerLobName(lobName) // lob name should be passes dynamic
      ?.then((response) => {
        dispatch(isLoadingStateReducer(false));
        if (response?.success) {
          setBlockDetails(response?.data?.blocks);
        }
      })
      ?.catch((err) => {
        dispatch(isLoadingStateReducer(false));
        showToast(err?.response?.data?.message, "error", true);
      });
  }, [lobName]);

  useEffect(() => {
    if (isReassign) {
      setSelectValue(1);
      getVendorBlock({ caseId })
        .then((data) => {
          if (data?.success) {
            const assignedToInvestigatorsWithInvestigationStatus =
              data?.data?.assignedToInvestigatorsWithInvestigationStatus;

            setInvestigatorDetails(
              assignedToInvestigatorsWithInvestigationStatus?.[vendorId - 1]
                ?.investigatorDetails || []
            );
          }
        })
        .catch((error) => {
          dispatch(isLoadingStateReducer(false));
          showToast(error?.response?.data?.message, "error", true);
        });
    }
  }, [isReassign, caseId]);

  useEffect(() => {
    if (blockDetails) {
      const modifiedData = blockDetails?.map((item, index) => {
        let modifiedInvestigator =
          assignDataList?.[index]?.investigator?.filter(
            (data) => data <= selectValue
          ) || [];
        let isPrevSelected = false;
        if (
          isReassign &&
          investigatorDetails?.blocksAssigned?.includes(item?.block_master_id)
        ) {
          isPrevSelected = true;
        }
        if (
          isReassign &&
          investigatorDetails?.blocksAssigned?.includes(
            item?.block_master_id
          ) &&
          selectValue <= 1
        ) {
          modifiedInvestigator?.push(1);
        }

        return {
          ...item,
          isPrevSelected,
          investigator: modifiedInvestigator,
          isAssigned: modifiedInvestigator?.length ? true : false,
        };
      });

      setAssignDataList(modifiedData);
    }
  }, [blockDetails, selectValue, isReassign, investigatorDetails]);

  useEffect(() => {
    if (selectValue) {
      let vendorsData = Array(Number(selectValue))
        ?.fill(null)
        ?.map((val, index) => {
          let modifiedData = dataToSend?.[index] || {
            blocksAssigned: [],
            state: "",
            city: "",
            isSpecialised: null,
          };

          if (
            isReassign &&
            investigatorDetails?.blocksAssigned?.length &&
            index === 0
          ) {
            let {
              blocksAssigned = [],
              state = "",
              city = "",
              is_specialised = 0,
            } = investigatorDetails;
            let blocks = [...modifiedData.blocksAssigned, ...blocksAssigned];
            modifiedData = {
              blocksAssigned: [...new Set(blocks)],
              state: !modifiedData?.state ? state : modifiedData?.state,
              city: !modifiedData.city ? city : modifiedData?.city,
              isSpecialised:
                modifiedData.isSpecialised === null
                  ? is_specialised
                  : modifiedData.isSpecialised,
            };
          }
          return modifiedData;
        });
      setDataToSend(vendorsData);
    }
  }, [selectValue, isReassign, investigatorDetails]);

  useEffect(() => {
    try {
      window?.scroll(0, 0);
      getLocationList()
        ?.then((response) => {
          if (response?.success) {
            setDropdownData([...response?.data]);
          }
        })
        ?.catch((err) => {
          showToast(err?.response?.data?.message, "error", true);
        });
    } catch (err) {
      showToast("Error while fetching location list", "error", true);
    }
  }, []);

  return (
    <div className={style["assign_block_Container"]}>
      <div style={{ width: "60%" }}>
        <div className={style["assign_block_header_container"]}>
          <img
            className={style["backArrow_Image"]}
            src={backArrowBold}
            alt="backArrow"
            onClick={onBackClick}
          />
          <h1 className={style["assign_block_header"]}>Assign Block</h1>
        </div>
        <div className={style["count-vendor_container"]}>
          <p className={style["count_investigator"]}>Count of Vendor</p>
          <div className={style["customSelect-container"]}>
            <select
              className={style["select_container"]}
              onChange={handleChange}
              style={{ color: !selectValue ? "#ccc" : "inherit" }}
              value={selectValue}
              disabled={reassignType === "same"}
            >
              <option disabled hidden value="">
                Select
              </option>
              {vendorCountNumber?.map((number) => (
                <option
                  key={number?.vendor}
                  value={number?.vendor}
                  style={{ color: "black" }}
                >
                  {number?.vendor}
                </option>
              ))}
            </select>
          </div>
        </div>
        <h2 className={style["block_count_header"]}>{`Blocks${
          !isReassign ? " to be assigned" : ""
        }: ${blockDetails?.length}`}</h2>
        <div style={{ marginLeft: "3rem", marginTop: "1.5rem" }}>
          <Blocks
            blockName={blockDetails}
            blockData={modifiedBlockData}
            setBlockData={setModifiedBlockData}
          />
        </div>
        {selectValue && (
          <div style={{ marginLeft: "3rem", marginTop: "3.6rem" }}>
            <VendorCount
              showToast={showToast}
              count={selectValue}
              onApply={onApply}
            />
          </div>
        )}
      </div>
      <div style={{ width: "40%" }}>
        <VendorCountCard
          isReassign={isReassign}
          reassignType={reassignType}
          Vendorcount={dataToSend?.length}
          VendorsData={dataToSend}
          setDataToSend={setDataToSend}
          onAssign={onAssignBlockHandler}
          assignedBlocksData={assignDataList?.filter((obj) => obj?.isAssigned)}
          handleClick={handleClick}
          isFilterPopOverActive={isFilterPopOverActive}
          blockDetails={blockDetails}
          dropdownData={dropdownData}
          onRemoveItem={onRemoveItem}
          anchorEl={anchorEl}
          id={id}
        />
      </div>
      <CommonModal
        open={isManualAssignModelOpen}
        onClose={() => {
          setIsManualAssignModelOpen(false);
        }}
        width="44.3rem"
      >
        <ManuallyAssignCase
          caseId={caseId}
          data={manualPopupData}
          onSubmit={manualAssignHandler}
          isAllocatedCase={isAllocatedCase}
        />
      </CommonModal>
    </div>
  );
};

export default Assignblock;
